import React from 'react';
import { withWebView } from '../hoc/withWebView';
import SummitSubmissionContent from '../components/SummitSubmissionContent';

export default withWebView(SummitSubmissionContent, 'summit-submission'); 